import { jsx as _jsx } from "react/jsx-runtime";
import { Button, LL_H_C, ModuleFE_Toaster } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_VolatileImport } from '../ModuleFE_VolatileImport.js';
import './Component_DiseaseProfileImportSave.scss';
/**
 * "Save to KM" action for a volatile disease-profile preview, rendered into the
 * `disease-profile-import-save` slot at the bottom of the DP editor. Renders nothing on non-volatile
 * DP tabs. Mirrors Component_PathwayImportSave.
 *
 * The actual save (import → purge → close tab → hydrate caches → open editor) is orchestrated by
 * `ModuleFE_VolatileImport.commitDiseaseProfileImportToKm`, not here: a successful save closes this
 * tab and unmounts this component, so the async work must live in the (lifecycle-free) module.
 *
 * Stateless on purpose: Button drives its own in-progress loader off the async onClick (uncontrolled
 * mode), so there's nothing to track locally.
 */
export const Component_DiseaseProfileImportSave = (props) => {
    const importId = ModuleFE_VolatileImport.getImportIdForDiseaseProfile(props.tabId, props.diseaseProfileId);
    if (!importId)
        return null;
    const onSave = async () => {
        try {
            const result = await ModuleFE_VolatileImport.commitDiseaseProfileImportToKm(importId, props.tabId);
            if (result.status === 'missing-file')
                ModuleFE_Toaster.toastError('The original CSV is no longer available — please re-import to save.');
        }
        catch (error) {
            ModuleFE_Toaster.toastError(error instanceof Error ? error.message : 'Save failed.');
        }
    };
    return _jsx(LL_H_C, { className: 'component-disease-profile-import-save', children: _jsx(Button, { variant: 'primary', onClick: onSave, children: "Save to KM" }) });
};
//# sourceMappingURL=Component_DiseaseProfileImportSave.js.map